import React, { useState, useEffect } from 'react';
import { Subscription } from '../core/_models';

interface Props {
  subscription: Subscription | null;
  show: boolean;
  isLoading: boolean;
  onHide: () => void;
  onConfirm: (id: string, payload: any) => void;
}

export const SubscriptionEditModal: React.FC<Props> = ({ subscription, show, isLoading, onHide, onConfirm }) => {
  const [monthlyValue, setMonthlyValue] = useState<number>(0);
  const [cycle, setCycle] = useState<string>('MENSAL');

  useEffect(() => {
    if (subscription) {
      setMonthlyValue(subscription.monthly_value);
      setCycle(subscription.cycle);
    }
  }, [subscription]);

  if (!show || !subscription) return null;

  return (
    <>
      <div className='modal fade show d-block' tabIndex={-1} role='dialog' aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content bg-body'>
            <div className='modal-header border-bottom border-gray-200 dark:border-gray-700'>
              <h2 className='fw-bolder text-gray-900'>Editar Assinatura</h2>
              <div className='btn btn-icon btn-sm btn-active-icon-primary' onClick={onHide}>
                <i className='bi bi-x fs-1'></i>
              </div>
            </div>

            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='d-flex flex-column mb-8'>
                <label className='fs-6 fw-bold mb-2'>Cliente</label>
                <div className='d-flex flex-stack bg-light rounded p-4'>
                  <span className='fw-bolder text-gray-800'>{subscription.client?.user?.name || subscription.client?.nameResponsible || 'Desconhecido'}</span>
                  <span className='text-muted fw-bold'>ID: {subscription.code}</span>
                </div>
              </div>

              <div className='row g-4 mb-8'>
                <div className='col-lg-6'>
                  <label className='fs-6 fw-bold mb-2'>Valor Mensal (R$)</label>
                  <input
                    type='number'
                    step='0.01'
                    className='form-control form-control-solid'
                    value={monthlyValue}
                    onChange={(e) => setMonthlyValue(Number(e.target.value))}
                  />
                </div>
                <div className='col-lg-6'>
                  <label className='fs-6 fw-bold mb-2'>Periodicidade</label>
                  <select
                    className='form-select form-select-solid'
                    value={cycle}
                    onChange={(e) => setCycle(e.target.value)}
                  >
                    <option value='MENSAL'>Mensal</option>
                    <option value='SEMESTRAL'>Semestral</option>
                    <option value='ANUAL'>Anual</option>
                  </select>
                </div>
              </div>

              <div className='text-center pt-15'>
                <button type='reset' className='btn btn-light me-3' onClick={onHide}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={() => onConfirm(subscription.id, { monthly_value: monthlyValue, cycle })}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Salvando... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <span className='indicator-label'>Salvar Alterações</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};
